import { render, staticRenderFns } from "./MaintenanceReviews.vue?vue&type=template&id=34c70952&"
import script from "./MaintenanceReviews.vue?vue&type=script&lang=js&"
export * from "./MaintenanceReviews.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceReviews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports